import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/assets/arrow-left.svg'
import _imports_1 from '@/assets/settings-cog.svg'
import _imports_2 from '@/assets/filter.svg'
import _imports_3 from '@/assets/eye-off.svg'


const _hoisted_1 = {
  key: 0,
  class: "loader-block-select",
  role: "alert",
  title: "Data is loading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner",
  id: "loading-bar-spinner"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner-icon" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "back-btn" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Back Button"
}, null, -1)
const _hoisted_6 = { role: "main" }
const _hoisted_7 = { class: "display-row" }
const _hoisted_8 = { class: "progress-bar-background" }
const _hoisted_9 = ["aria-valuenow"]
const _hoisted_10 = { class: "display-row" }
const _hoisted_11 = { class: "num-highlight-text" }
const _hoisted_12 = { class: "settings-block" }
const _hoisted_13 = {
  key: 0,
  class: "active-setting"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "setting-cog",
  src: _imports_1,
  alt: "Setting icon"
}, null, -1)
const _hoisted_15 = { class: "tooltip-main-data setting-data" }
const _hoisted_16 = {
  class: "active-setting-text",
  tabindex: "0",
  "aria-describedby": 'active-settings'
}
const _hoisted_17 = {
  class: "tooltip-data-filter",
  tabindex: "0"
}
const _hoisted_18 = {
  class: "t-texts",
  title: "Display all active settings"
}
const _hoisted_19 = {
  id: "active-settings",
  role: "tooltip"
}
const _hoisted_20 = { class: "active-setting" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "setting-cog",
  src: _imports_2,
  alt: "Filter icon"
}, null, -1)
const _hoisted_22 = { class: "tooltip-main-data" }
const _hoisted_23 = {
  class: "active-setting-text",
  tabindex: "0",
  "aria-describedby": 'active-filters'
}
const _hoisted_24 = {
  class: "tooltip-data-filter",
  tabindex: "0"
}
const _hoisted_25 = {
  class: "t-texts",
  title: "Display Active Entity Types"
}
const _hoisted_26 = { id: "active-filters" }
const _hoisted_27 = { class: "tooltip-main-data dataset-data" }
const _hoisted_28 = {
  class: "active-setting-text",
  tabindex: "0",
  "aria-describedby": 'active-datasets'
}
const _hoisted_29 = {
  class: "tooltip-data-filter",
  tabindex: "0"
}
const _hoisted_30 = {
  class: "t-texts",
  title: "Display Active Dataset"
}
const _hoisted_31 = { id: "active-datasets" }
const _hoisted_32 = {
  key: 0,
  class: "display-row-offcenter"
}
const _hoisted_33 = { class: "num-results-info" }
const _hoisted_34 = {
  key: 1,
  class: "display-row-offcenter"
}
const _hoisted_35 = { class: "title" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "arrow left" }, null, -1)
const _hoisted_37 = {
  key: 2,
  class: "entity-search-bar-container"
}
const _hoisted_38 = {
  key: 0,
  class: "entity-failure-message"
}
const _hoisted_39 = {
  key: 3,
  class: "display-row-offcenter"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.00023 2.828L2.05023 7.778L0.63623 6.364L7.00023 0L13.3642 6.364L11.9502 7.778L7.00023 2.828Z",
  fill: "#525455"
}, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.00023 5.17205L11.9502 0.222046L13.3642 1.63605L7.00023 8.00005L0.63623 1.63605L2.05023 0.222046L7.00023 5.17205Z",
  fill: "#525455"
}, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_45 = {
  class: "matched-entity-section",
  role: "list",
  "aria-label": "Scanned highlights"
}
const _hoisted_46 = ["aria-label", "id", "onClick", "onKeydown"]
const _hoisted_47 = { class: "matching-entities" }
const _hoisted_48 = { class: "select-matching-entities" }
const _hoisted_49 = { class: "match-entities" }
const _hoisted_50 = { class: "match-title" }
const _hoisted_51 = { value: "all" }
const _hoisted_52 = ["value"]
const _hoisted_53 = {
  class: "entity-wrapper",
  role: "list"
}
const _hoisted_54 = ["onMouseenter"]
const _hoisted_55 = ["onClick", "onKeydown"]
const _hoisted_56 = ["title"]
const _hoisted_57 = { class: "entity-info-block" }
const _hoisted_58 = ["aria-label"]
const _hoisted_59 = { key: 0 }
const _hoisted_60 = {
  key: 1,
  class: "entity-links-wrapper"
}
const _hoisted_61 = ["aria-label"]
const _hoisted_62 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "7",
  viewBox: "0 0 9 5",
  fill: "none"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.81259 1.72918L5.81259 2.35634C5.81261 2.64445 5.74472 2.92975 5.6128 3.19594C5.48088 3.46212 5.28751 3.70399 5.04374 3.90772C4.79997 4.11145 4.51057 4.27305 4.19207 4.3833C3.87357 4.49355 3.5322 4.55029 3.18745 4.55027L2.99998 4.55005C2.30375 4.55005 1.63604 4.31891 1.14373 3.90746C0.651423 3.49602 0.374848 2.93798 0.374848 2.35612C0.374848 1.77425 0.651424 1.21621 1.14373 0.80477C1.63604 0.393327 2.30375 0.162182 2.99998 0.162182L2.99998 0.789336C2.75307 0.788433 2.50837 0.828297 2.27993 0.906642C2.0515 0.984986 1.84383 1.10027 1.66885 1.24587C1.49387 1.39147 1.35502 1.56452 1.26028 1.75508C1.16554 1.94565 1.11677 2.14998 1.11677 2.35634C1.11677 2.5627 1.16554 2.76703 1.26028 2.95759C1.35502 3.14816 1.49387 3.32121 1.66885 3.46681C1.84383 3.61241 2.0515 3.72769 2.27993 3.80603C2.50837 3.88438 2.75306 3.92424 2.99998 3.92334L3.18772 3.92334C3.6849 3.92328 4.1617 3.75819 4.51326 3.46437C4.86482 3.17056 5.06236 2.77208 5.06244 2.35656V1.7294L5.81259 1.72963L5.81259 1.72918ZM6.00006 4.55005L6.00006 3.92334C6.24698 3.92424 6.49168 3.88438 6.72011 3.80603C6.94854 3.72769 7.15621 3.61241 7.33119 3.46681C7.50617 3.32121 7.64502 3.14816 7.73976 2.95759C7.8345 2.76703 7.88327 2.5627 7.88327 2.35634C7.88327 2.14998 7.8345 1.94565 7.73976 1.75508C7.64502 1.56452 7.50617 1.39147 7.33119 1.24587C7.15621 1.10027 6.94854 0.984986 6.72011 0.906641C6.49168 0.828297 6.24698 0.788433 6.00006 0.789336L5.81232 0.789336C5.31514 0.789399 4.83834 0.95449 4.48678 1.2483C4.13522 1.54212 3.93768 1.9406 3.93761 2.35612L3.93761 2.98327L3.18745 2.98305L3.18745 2.35634C3.18744 2.06822 3.25532 1.78292 3.38724 1.51674C3.51916 1.25055 3.71253 1.00869 3.9563 0.804959C4.20007 0.60123 4.48947 0.439627 4.80797 0.329376C5.12648 0.219126 5.46785 0.162388 5.81259 0.162403L6.00006 0.162624C6.69629 0.162624 7.364 0.39377 7.85631 0.805213C8.34862 1.21666 8.62519 1.77469 8.62519 2.35656C8.62519 2.93843 8.34862 3.49646 7.85631 3.90791C7.364 4.31935 6.69629 4.55049 6.00006 4.55049V4.55005Z",
  fill: "#244D6F"
}, null, -1)
const _hoisted_64 = { class: "t-texts" }
const _hoisted_65 = {
  key: 0,
  title: "$t('EntitySelectView.also_known')"
}
const _hoisted_66 = { key: 1 }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = ["title"]
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = {
  key: 1,
  class: "hidden-dataset-tooltip"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Filtered Dataset"
}, null, -1)
const _hoisted_73 = { key: 0 }
const _hoisted_74 = ["title"]
const _hoisted_75 = { style: {"margin-bottom":"10px"} }
const _hoisted_76 = ["title"]
const _hoisted_77 = { key: 1 }
const _hoisted_78 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidePanelHeader = _resolveComponent("SidePanelHeader")!
  const _component_NoResults = _resolveComponent("NoResults")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SidePanelHeader),
    (_ctx.loading || _ctx.$route.params.percentComplete != '100')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.entities.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "header-btn-block",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args))),
          role: "navigation"
        }, [
          _createElementVNode("a", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("EntitySelectView.back")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("div", null, [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                role: "progressbar",
                "aria-valuenow": Number(_ctx.$route.params.percentComplete),
                class: "progress-bar-foreground",
                style: _normalizeStyle('width:' + _ctx.$route.params.percentComplete + '%')
              }, _toDisplayString(_ctx.$route.params.percentComplete) + "% ", 13, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$route.params.numHighlights) + " " + _toDisplayString(_ctx.$t("EntitySelectView.results_found")), 1),
            _createElementVNode("button", {
              class: "cancel-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stopScan && _ctx.stopScan(...args)))
            }, _toDisplayString(_ctx.$t("EntitySelectView.stop_scan")), 1)
          ])
        ], 512), [
          [_vShow, _ctx.$route.params.percentComplete != '100']
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_12, [
            (_ctx.modifiedSettingsCount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.modifiedSettingsCount) + " " + _toDisplayString(_ctx.$t("EntitySelectView.modified_settings")), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.pluginSettings?.descriptor?.join(", ")), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("h2", _hoisted_23, _toDisplayString(_ctx.$t("EntitySelectView.entity_types")) + ": " + _toDisplayString(_ctx.filterSettings.type?.filters.length < 11
                                        ? _ctx.filterSettings.type?.filters.length
                                        : "All"), 1),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("p", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.filterSettings.type?.filters.join(", ")
                                            || "All entities filtered"), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.$t("EntitySelectView.datasets")) + ": " + _toDisplayString(_ctx.filterSettings.graph?.filters.length < 8
                                        ? _ctx.filterSettings.graph?.filters.length
                                        : "All"), 1),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("p", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.filterSettings.graph?.filters.join(
                                                ", ",
                                            ) || "No datasets selected"), 1)
                  ])
                ])
              ])
            ])
          ]),
          (Number(_ctx.$route.params.numHighlights) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$route.params.numHighlights) + " " + _toDisplayString(_ctx.$t("EntitySelectView.results_found")), 1)
              ]))
            : _createCommentVNode("", true),
          (Number(_ctx.$route.params.numHighlights) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("h2", _hoisted_35, [
                  _hoisted_36,
                  _createTextVNode(_toDisplayString(_ctx.$t("EntitySelectView.hover_on_a")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (Number(_ctx.$route.params.numHighlights) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["entity-search-bar", {
                            'entity-search-bar-failure': _ctx.entitySearchNoResults 
                        }]),
                  type: "text",
                  placeholder: "Or search for an entity...",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entitySearchValue) = $event)),
                  onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.exactMatchScan && _ctx.exactMatchScan(...args)), ["enter"]))
                }, null, 34), [
                  [_vModelText, _ctx.entitySearchValue]
                ]),
                (_ctx.entitySearchNoResults)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_38, "No results found!"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (Number(_ctx.$route.params.numHighlights) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                (_openBlock(), _createElementBlock("svg", {
                  class: "display-row",
                  style: {"padding-left":"5px","padding-right":"5px","cursor":"pointer","height":"40px"},
                  tabindex: "0",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.focusOnPreviousHighlight && _ctx.focusOnPreviousHighlight(...args))),
                  onKeydown: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.focusOnPreviousHighlight && _ctx.focusOnPreviousHighlight(...args)), ["enter"])),
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "25",
                  height: "10",
                  viewBox: "0 0 14 8",
                  fill: "none"
                }, _hoisted_41, 32)),
                (_openBlock(), _createElementBlock("svg", {
                  class: "display-row",
                  style: {"padding-left":"5px","padding-right":"5px","cursor":"pointer","height":"40px"},
                  tabindex: "0",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.focusOnNextHighlight && _ctx.focusOnNextHighlight(...args))),
                  onKeydown: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.focusOnNextHighlight && _ctx.focusOnNextHighlight(...args)), ["enter"])),
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "25",
                  height: "10",
                  viewBox: "0 0 14 8",
                  fill: "none"
                }, _hoisted_43, 32)),
                _withDirectives(_createElementVNode("p", { style: {"padding-left":"5px","user-select":"none","margin-top":"11px"} }, " (" + _toDisplayString(_ctx.focusedHighlight) + "/" + _toDisplayString(_ctx.$route.params.numHighlights) + ") ", 513), [
                  [_vShow, _ctx.focusedHighlight > 0]
                ])
              ]))
            : _createCommentVNode("", true),
          (Number(_ctx.$route.params.numHighlights) == 0)
            ? (_openBlock(), _createBlock(_component_NoResults, { key: 4 }))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.$route.params.percentComplete == '100']
        ]),
        _hoisted_44,
        _withDirectives(_createElementVNode("div", _hoisted_45, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highlights, (highlight, index) => {
            return (_openBlock(), _createElementBlock("div", {
              style: {"display":"block"},
              role: "listitem",
              "aria-label": highlight,
              tabindex: "0",
              id: 'highlight-' + index,
              key: index,
              onClick: ($event: any) => (_ctx.focusOnHighlight(index)),
              onKeydown: _withKeys(($event: any) => (_ctx.focusOnHighlight(index)), ["enter"]),
              class: _normalizeClass(
                        _ctx.focusedHighlight - 1 == index
                            ? 'matched-entities hovered'
                            : 'matched-entities'
                    )
            }, _toDisplayString(highlight), 43, _hoisted_46))
          }), 128))
        ], 512), [
          [_vShow, _ctx.$route.params.percentComplete == '100' && !_ctx.loading]
        ])
      ], 512), [
        [_vShow, !_ctx.showResults]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_48, _toDisplayString(_ctx.$t("EntitySelectView.select_matching_entity")), 1),
          _createElementVNode("h3", _hoisted_49, _toDisplayString(_ctx.entities.length) + " " + _toDisplayString(_ctx.$t("EntitySelectView.entities_matching")) + ": ", 1),
          _createElementVNode("h4", _hoisted_50, "\"" + _toDisplayString(_ctx.$route.params.text) + "\"", 1)
        ]),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.typeFilter) = $event)),
          onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.filterByType && _ctx.filterByType(...args))),
          class: "type-filter",
          title: "Filter Entities By Type"
        }, [
          _createElementVNode("option", _hoisted_51, _toDisplayString(_ctx.$t("EntitySelectView.all_types")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTypes, (type, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: type
            }, _toDisplayString(type), 9, _hoisted_52))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.typeFilter]
        ]),
        _createElementVNode("div", _hoisted_53, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedEntities, (entity, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "tooltip-main-data entity-data",
              key: index,
              role: "listitem",
              onMouseenter: ($event: any) => (_ctx.tooltipActive(entity, $event, index))
            }, [
              _createElementVNode("div", {
                class: "entity",
                tabindex: "0",
                onClick: ($event: any) => (_ctx.selectEntity(entity['label'], entity['uri'])),
                onKeydown: _withKeys(($event: any) => (_ctx.selectEntity(entity['label'], entity['uri'])), ["enter"])
              }, [
                _createElementVNode("h5", {
                  class: "entity-label",
                  title: entity['label']
                }, _toDisplayString(entity["label"]), 9, _hoisted_56),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("span", {
                    class: "entity-type",
                    "aria-label": entity['type']
                  }, _toDisplayString(entity["type"]), 9, _hoisted_58),
                  (entity['links'] != null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, " · "))
                    : _createCommentVNode("", true),
                  (entity['links'] != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("span", {
                          class: "entity-links",
                          "aria-label": entity['links']
                        }, _toDisplayString(entity["links"]), 9, _hoisted_61),
                        (_openBlock(), _createElementBlock("svg", _hoisted_62, [
                          _createElementVNode("title", null, _toDisplayString(_ctx.$t("EntitySelectView.connected_entities")), 1),
                          _hoisted_63
                        ]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 40, _hoisted_55),
              _createElementVNode("div", {
                class: "tooltip-data-filter",
                style: _normalizeStyle({top: _ctx.tooltipY[0], '--tooltipArrow': _ctx.tooltipY[1]}),
                tabindex: "0"
              }, [
                _createElementVNode("ul", _hoisted_64, [
                  _createElementVNode("li", null, [
                    (entity['altLabel'])
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_65, _toDisplayString(_ctx.$t("EntitySelectView.also_known")), 1))
                      : _createCommentVNode("", true),
                    (entity['altLabel'])
                      ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(entity["altLabel"]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.showTooltipDataset)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_67, [
                        _createElementVNode("h3", {
                          title: _ctx.$t('EntitySelectView.datasets')
                        }, _toDisplayString(_ctx.$t("EntitySelectView.datasets")), 9, _hoisted_68),
                        (entity.datasets?.length == 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_69, "Loading..."))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entity.datasets, (dataset, datasetKey) => {
                          return (_openBlock(), _createElementBlock("div", { key: datasetKey }, [
                            (_ctx.datasetsToDisplay.includes(dataset.uri))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_70, _toDisplayString(dataset.name ?? dataset.uri), 1))
                              : _createCommentVNode("", true),
                            (_ctx.datasetsToHide.includes(dataset.uri))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_71, [
                                  _createTextVNode(_toDisplayString(dataset.name ?? dataset.uri) + " ", 1),
                                  _hoisted_72
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entity, (value, pred) => {
                    return (_openBlock(), _createElementBlock("li", { key: pred }, [
                      ((pred as string) == 'dates')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _createElementVNode("h3", {
                              title: _ctx.$t('EntitySelectView.birth')
                            }, _toDisplayString(_ctx.$t("EntitySelectView.birth")), 9, _hoisted_74),
                            _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.datasetsToDisplay.includes((value as any)["birthDate"]?.graph) ? (value as any)["birthDate"].value : "Unknown") + ", " + _toDisplayString(_ctx.datasetsToDisplay.includes((value as any)["birthPlace"]?.graph) ? (value as any)["birthPlace"].value : "Unknown"), 1),
                            _createElementVNode("h3", {
                              title: _ctx.$t('EntitySelectView.death')
                            }, _toDisplayString(_ctx.$t("EntitySelectView.death")), 9, _hoisted_76),
                            _createElementVNode("p", null, _toDisplayString(_ctx.datasetsToDisplay.includes((value as any)["deathDate"]?.graph) ? (value as any)["deathDate"].value : "Unknown") + ", " + _toDisplayString(_ctx.datasetsToDisplay.includes((value as any)["deathPlace"]?.graph) ? (value as any)["deathPlace"].value : "Unknown"), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (((pred as string) == 'pursuits' || (pred as string) == 'works' || (pred as string) == 'creators' || (pred as string) == 'types' || (pred as string) == 'createDates' || (pred as string) == 'bornHere' || (pred as string) == 'diedHere' || (pred as string) == 'members' || (pred as string) == 'groups') && _ctx.tooltipArrayIncludesDisplayDataset(value))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            _createElementVNode("h3", {
                              title: _ctx.$t('EntitySelectView.' + pred)
                            }, _toDisplayString(_ctx.$t("EntitySelectView." + pred)), 9, _hoisted_78),
                            _createElementVNode("p", null, _toDisplayString(_ctx.processTooltipArray(value)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ], 4)
            ], 40, _hoisted_54))
          }), 128))
        ])
      ], 512), [
        [_vShow, _ctx.entities.length > 0]
      ])
    ])
  ], 64))
}